import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

/**
 * Ce qui se passe pendant une génération.
 *
 * Honnêteté de l'indicateur — la contrainte qui a dicté ce composant : une
 * génération est UN SEUL appel au modèle, qui renvoie tout d'un bloc. Il
 * n'existe aucune progression réelle à mesurer, et aucun moyen de savoir
 * quelle partie du thème est « déjà faite ».
 *
 * On n'affiche donc jamais d'étape cochée, ni de pourcentage, ni de barre
 * qui se remplit : ce serait inventer une information. Ce composant montre
 * ce qui est réellement vrai — la liste de ce que l'assistant est en train
 * de composer, et le fait que ça tourne. Le libellé défile pour donner une
 * respiration à l'attente, sans jamais prétendre qu'une étape est terminée.
 */
const ROTATE_MS = 2200;

export default function AIProgress({ steps, label = "Génération en cours" }) {
  const [index, setIndex] = useState(0);
  const items = steps && steps.length ? steps : [];

  useEffect(() => {
    if (items.length < 2) return undefined;
    const id = setInterval(() => setIndex((i) => (i + 1) % items.length), ROTATE_MS);
    return () => clearInterval(id);
  }, [items.length]);

  return (
    <div
      className="flex items-start gap-3 bg-sand border border-stone rounded-sm p-3"
      data-testid="ai-progress"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-4 w-4 text-copper shrink-0 mt-0.5 animate-spin" />
      <div className="min-w-0">
        <p className="text-sm text-ink">{label}</p>
        {!!items.length && (
          <>
            <p className="text-xs text-graphite mt-0.5" data-testid="ai-progress-current">
              L&apos;assistant compose : {items[index]}
            </p>
            {/* La liste complète reste visible : l'utilisateur voit ce qu'il
                va recevoir, sans qu'on lui laisse croire que les entrées
                déjà passées sont bouclées. */}
            <p className="text-[11px] text-ash mt-1">{items.join(" · ")}</p>
          </>
        )}
      </div>
    </div>
  );
}
